export const webGames = [
  {
    id: 'mines-garden',
    name: 'Mines Garden',
    slug: 'mines-garden',
    category: 'Logic Puzzle',
    description: 'Clear a hidden minefield with careful clues, smart flags, and quick logic.',
    image: '/images/games/mines-garden.png',
    instructions: [
      'Reveal safe tiles to uncover number clues.',
      'Numbers show how many mines touch that tile.',
      'Use flag mode or right-click to mark suspected mines.',
      'Reveal every safe tile without triggering a mine.',
    ],
    thumbnail: 'MG',
    gameType: 'mines',
    status: 'live',
    seoTitle: 'Play Mines Garden Online',
    seoDescription: 'Play Mines Garden, a free online minesweeper-style logic game with difficulty levels and timer.',
    faq: [
      {
        question: 'How do I flag a mine?',
        answer: 'Use the Flag Mode button on mobile or right-click a tile on desktop.',
      },
      {
        question: 'What difficulties are available?',
        answer: 'Mines Garden includes easy, medium, and hard boards.',
      },
    ],
  },
  {
    id: 'snake-garden',
    name: 'Snake Garden',
    slug: 'snake',
    category: 'Arcade Puzzle',
    description: 'Guide the growing trail through a clean garden board, collect petals, and avoid your own path.',
    image: '/images/games/snake-garden.png',
    instructions: [
      'Use arrow keys, WASD, or the touch controls to move.',
      'Collect petals to grow and score points.',
      'Avoid the walls and your own trail.',
    ],
    thumbnail: 'SG',
    gameType: 'snake',
    status: 'live',
    seoTitle: 'Play Snake Garden Online',
    seoDescription: 'Play Snake Garden, a free browser snake game with score tracking and touch controls.',
    faq: [
      {
        question: 'Can I play Snake Garden on mobile?',
        answer: 'Yes. Snake Garden includes touch controls for phones and tablets.',
      },
      {
        question: 'Does Snake Garden save my best score?',
        answer: 'Yes. Your best score is saved locally on your device.',
      },
    ],
  },
  {
    id: 'memory-bloom',
    name: 'Memory Bloom',
    slug: 'memory-match',
    category: 'Memory',
    description: 'Flip tiles, remember the patterns, and match every pair with the fewest moves.',
    image: '/images/games/memory-bloom.png',
    instructions: [
      'Choose easy, medium, or hard difficulty.',
      'Flip two cards at a time to find matching pairs.',
      'Complete the board with fewer moves and less time.',
    ],
    thumbnail: 'MB',
    gameType: 'memory',
    status: 'live',
    seoTitle: 'Play Memory Bloom Online',
    seoDescription: 'Play Memory Bloom, a free online memory matching game with difficulty levels and timer.',
    dailyChallenge: true,
    faq: [
      {
        question: 'What difficulties are available?',
        answer: 'Memory Bloom includes easy, medium, and hard boards.',
      },
      {
        question: 'What does the daily challenge mean?',
        answer: 'The daily challenge highlights Memory Bloom as the featured replay game of the day.',
      },
    ],
  },
  {
    id: 'petal-2048',
    name: 'Petal 2048',
    slug: '2048',
    category: 'Number Puzzle',
    description: 'Slide matching tiles together, build bigger values, and chase a new best score.',
    image: '/images/games/petal-2048.png',
    instructions: [
      'Use arrow keys, WASD, or swipes to slide every tile.',
      'Matching numbers merge into a higher tile.',
      'Keep empty spaces available so the board does not lock.',
    ],
    thumbnail: '20',
    gameType: '2048',
    status: 'live',
    seoTitle: 'Play Petal 2048 Online',
    seoDescription: 'Play Petal 2048, a free online 2048 puzzle game with saved best score and touch support.',
    faq: [
      {
        question: 'How do I win Petal 2048?',
        answer: 'Merge matching tiles until you create the 2048 tile, then keep playing for a higher score.',
      },
      {
        question: 'Can I use swipe controls?',
        answer: 'Yes. Petal 2048 supports keyboard controls and touch swipes.',
      },
    ],
  },
];

export const getGameBySlug = (slug) => webGames.find((game) => game.slug === slug);

export const getMoreGames = (currentSlug, limit = 3) =>
  webGames.filter((game) => game.slug !== currentSlug && game.status === 'live').slice(0, limit);
